/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

export default function Seo({
  title, description, keywords, type, image, url, canonicalUrl,
}) {
  const siteName = 'Teknisi CNC';
  const siteUrl = 'https://teknisi.space';
  const defaultDescription = 'Jasa teknisi CNC profesional untuk service, perbaikan, maintenance, dan retrofit mesin CNC & Laser CO2. Layanan panggilan ke seluruh Indonesia. Teknisi berpengalaman siap membantu masalah mesin Anda.';
  const defaultKeywords = 'teknisi cnc, service cnc, perbaikan cnc, jasa servis mesin cnc, teknisi cnc panggilan, maintenance cnc, retrofit cnc, servis laser co2, teknisi mesin cnc, service cnc jakarta, perbaikan mesin cnc, jasa teknisi cnc, upgrade cnc, cnc router service, cnc milling service, service mesin industri, perbaikan mesin industri';
  const defaultImage = `${siteUrl}/logo512.png`;
  const currentUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;

  return (
    <Helmet>
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl || currentUrl} />
      
      {/* Standard Metadata */}
      <title>{title ? `${title} | ${siteName}` : `Teknisi CNC Profesional | Jasa Service & Perbaikan Mesin CNC Indonesia - ${siteName}`}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="author" content={siteName} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:title" content={title || `Teknisi CNC Profesional - ${siteName}`} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:url" content={url || currentUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="id_ID" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || `Teknisi CNC Profesional - ${siteName}`} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />
    </Helmet>
  );
}

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  canonicalUrl: PropTypes.string,
};

Seo.defaultProps = {
  title: null,
  description: null,
  keywords: null,
  type: 'website',
  image: null,
  url: null,
  canonicalUrl: null,
};
